/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
import { Nullable } from '../../@types/common';
import * as moment from 'moment';
import { chronicCareCode } from '../../constants/formConstants';
import { getGroupNumber } from '../../utils/groups/helpers';

export enum SpecialCasesEntryType {
  array = 'array',
  arrayWithStartDate = 'arrayWithStartDate'
}

export const requiredMultiValidator = (values: Nullable<Array<any>>) => {
  return Array.isArray(values) && values.length > 0;
};

export const withStartDateValidator = (value: Nullable<Record<'start_dt', Nullable<string>>>) => {
  return value && value.start_dt;
};

export const requiredMultiWithStartDate = (values: Nullable<Array<Record<'start_dt', Nullable<string>>>>) => {
  return requiredMultiValidator(values) && values?.every(withStartDateValidator);
};

export const dateInFuture = (value: Nullable<string>): boolean => {
  return value ? moment.utc(value).isAfter(moment.utc()) : false;
};

export const chronicCareFieldValidation = (_currentValue, formState, meta) => {
  if (meta.name.includes('groups')) {
    const groupNumber = getGroupNumber(meta.name);
    if (isFinite(groupNumber) && formState?.groups && formState?.groups[groupNumber]) {
      const checkedChronicCareProductsState: { isChecked: boolean }[] = Object.keys(
        formState.groups[groupNumber]
      ).reduce((acc: { isChecked: boolean }[], key: string) => {
        if (chronicCareCode.some((code) => key.includes(code)) && key.includes('isEnabled')) {
          return [...acc, { isChecked: formState.groups[groupNumber][key] }];
        }
        return acc;
      }, []);
      if (checkedChronicCareProductsState.every((value) => value.isChecked === false) && meta.dirty) {
        return 'Required';
      }
      return '';
    }
  }
  return '';
};

export const chronicCareValidation = (errorName, { values, errors }) => {
  const groupNumber = getGroupNumber(errorName);
  if (isFinite(groupNumber) && values?.groups && values?.groups[groupNumber]) {
    const chronicCareProducts = Object.keys(values.groups[groupNumber]).filter((key) =>
      chronicCareCode.some((code) => key.includes(code) && key.includes('isEnabled'))
    );
    return chronicCareProducts.every((key) => values.groups[groupNumber][key] === false);
  }
  return false;
};
